import { Report } from "../Interfaces/TableInterfaces";
import { Packet } from "../Interfaces/commonDtos";
import { DropdownItem } from "../Interfaces/dropdownInterfaces";
import {
  IAddEditSahraUserGroupFormValues,
  ISahraUserGroupsByAccountReport,
  ISahraUserGroupsByAccountSearchParam,
  ISahraUserGroupsReport,
  ISahraUserGroupsSearchParam,
} from "../Interfaces/sahraUserGroupsInterfaces";
import {
  deleteRequest,
  getRequest,
  getTable,
  postRequest,
  putRequest,
} from "./requestTemplates";

export const getsahraUserGroup = (): Promise<DropdownItem[]> =>
  getRequest("/v1/sahraUserGroup/get");

export const getsahraUserGroupTable = (
  searchParam: ISahraUserGroupsSearchParam,
  offset: number | null,
  pageSize: number | null
): Promise<Report<ISahraUserGroupsReport>> =>
  getTable<ISahraUserGroupsSearchParam, ISahraUserGroupsReport>(
    "/v1/sahraUserGroup/table",
    searchParam,
    offset,
    pageSize
  );

export const getSahraUserGroupsByAccountTable = (
  searchParam: ISahraUserGroupsByAccountSearchParam,
  offset: number | null,
  pageSize: number | null,
): Promise<Report<ISahraUserGroupsByAccountReport>> =>
  getTable<
    ISahraUserGroupsByAccountSearchParam,
    ISahraUserGroupsByAccountReport
  >("/v1/sahraUserGroup/account/table", searchParam, offset, pageSize);

export const addSahraUserGroup = (
  formValues: IAddEditSahraUserGroupFormValues
): Promise<Packet<boolean>> =>
  postRequest("/v1/sahraUserGroup/add", formValues);

export const editSahraUserGroup = (
  formValues: IAddEditSahraUserGroupFormValues
): Promise<Packet<boolean>> =>
  putRequest("/v1/sahraUserGroup/edit", formValues);

export const deleteSahraUserGroup = (id: number): Promise<Packet<boolean>> =>
  deleteRequest(`/v1/sahraUserGroup/delete?id=${id}`);
